window.addEventListener('load', function () {

  var is_visible = true;
  var giftAddedThisUpdate = false;

  //PRODUCT PAGE
  if (window.location.href.indexOf("/products/") > -1) {
    $(window).scroll(function () {
      var top_of_element = $("button.add-to-cart").offset().top;
      var bottom_of_element = $("button.add-to-cart").offset().top + $("button.add-to-cart").outerHeight();
      if ($("button.tdf_normal_btn").length) {
        var bundle_bottom_of_element = $("button.tdf_normal_btn").offset().top + $("button.tdf_normal_btn").outerHeight();
      }

      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      var top_of_screen = $(window).scrollTop();

      //if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
      if (top_of_screen < bottom_of_element || top_of_screen < bundle_bottom_of_element) {
        // the element is visible, do something
        $('.sticky__AddToCart').fadeOut();

      }
      else {
        if ($('.product-block .product-single__title')[0]) {
          var prod_title = $('.product-block .product-single__title')[0].outerHTML;
        }

        if ($('.product-block .product__price.on-sale')[0]) {
          var prod_price_on_sale = $('.product-block .product__price.on-sale')[0].outerHTML;
        }
        else {
          var prod_price_on_sale = '';
        }
        if ($('.product-block .product__price')[0]) {
          var prod_price = $('.product-block .product__price')[0].outerHTML;
        }
        let prod_price_group = '<div class="prod_price"/>' + prod_price + prod_price_on_sale + '</div>';
        if ($('.product-block .product__price-savings')[0]) {
          var prod_save = '<div class="prod_savings"/>' + $('.product-block .product__price-savings')[0].outerHTML + '</div>';
        }
        else {
          var prod_save = '';
        }
        if ($('.product-block .add-to-cart')) {
          let add_to_cart_btn = $('.product-block .add-to-cart');
          let bundle_add_to_cart_btn = $('.tdf_normal_btn');
          if (is_visible) {
            // the element is not visible, do something else
            $('.transition-body').addClass('position-relative');
            if (bundle_add_to_cart_btn.length) {
              var sticky_addToCart = $('<button class="btn"/>').text('Add To Cart').click(function () { bundle_add_to_cart_btn.click(); });
            }
            else if (add_to_cart_btn[0]) {
              ;
              if (add_to_cart_btn[0].disabled) {
                var sticky_addToCart = $('<button class="btn"/>').prop('disabled', true).text('Sold Out');
              }
              else {
                var sticky_addToCart = $('<button class="btn"/>').text('Add To Cart').click(function () { add_to_cart_btn.click(); });
              }
            }
            var sticky_content = $('<div class="prod_details"/>').html('<div class="prod_price_group"/>' + prod_price_group + prod_save + '</div>').append(sticky_addToCart);
            $('#MainContent').before($('<div class="sticky__AddToCart"/>').html(sticky_content).prepend(prod_title));
            $('.sticky__AddToCart').slideDown();
            is_visible = false;
          }
          else {
            $('.sticky__AddToCart').slideDown();
          }
        }
      }
    });

    if ($('.tdf_normal_btn').length == 0) {
      $('.product-block .product-single__form').css('display', 'block');
    }
    if (window.location.href.indexOf('#notifyme') > -1) {
      $('a.btn.btn--full.klaviyo-bis-trigger')[0].click();
    }

    // Progress bars
    $(document).ready(function () {
      $('.progress .progress-bar').css("width",
        function () {
          return ($(this).attr("aria-valuenow") / $(this).attr("aria-valuemax")) * 100 + "%";
        }
      )
    });
    var urlPath = window.location.pathname.split("/products/");
    shopPromotions.forEach(function (promo) {
      if (promo.promo_collection_products.indexOf(urlPath[1]) > -1) {
        $('.script-sale--custom-product').show();
        $('.product__price').hide();
        $('.sale-script--price').show();
        $('.sale-script--price .product__price').show();
      }

    });
  }
  //COLLECTION PAGE
  if (window.location.href.indexOf("/collections/") > -1 && window.location.href.indexOf("/products/") < 0) {
    function SectionUpdate() {
      let activeCollection = window.location.href.split('/')[4].split('?')[0];

      $('.blog__section').each(function () {
        if (!$(this).hasClass('hide')) {
          $(this).addClass('hide');
        }
      });

      $('.promo-grid div.flex-grid__item[class*="type-"]').each(function () {
        if (!$(this).hasClass('hide') && $(this).attr('id') != '') {
          $(this).addClass('hide');
        }
      });

      $.get("/collections/" + activeCollection + ".json", function (data) {
        $('[id^="shopify-section-template--"][id$="__collection-header"] .section-header__title').text(data.collection.title);
      });
      $('.footer-promotions #' + activeCollection).removeClass("hide").show();
      $('.promo-grid #' + activeCollection).removeClass("hide").show();
      //activeCollection = activeCollection.replace(/-/g, " ");
      //$('#shopify-section-collection-header .section-header__title').text(activeCollection);
    }

    if (window.location.href.indexOf("collections/canada-day-flash-sale-2024") > -1) {
      document.body.classList.add("canada-day-flash-sale-2024");
    }

    function renderPREEZIE() {
      //PREEZIE COLLECTION PAGE
      if (window.location.href.indexOf(".com") > -1) {
        //PREEZIE
        var cookware = ['-cookware', '/skillet', '/saute-pan', '/stock-pot', '/avalon-series', '/oberon-series', '/frying-pan'];
        var non_knives = ['/cutting-boards', '/aprons', '/culinary-tools', '/whetstones', '/honing-rods', '/knife-roll', '/knife-bag', '/blocks-and-stands'];
        var new_url = location.href;
        var KNIFE_SET = '29e09a1b-43a5-4d3d-be39-08d8c0c9f622',
          CHEF = 'daf57127-baa6-4f93-be3b-08d8c0c9f622',
          BREAD = 'b35a871d-8c70-4070-be3c-08d8c0c9f622',
          CLEAVER = '1c6ebc44-78dc-4edf-be3d-08d8c0c9f622',
          PARING = 'c8d9ea49-b8e4-4916-be3e-08d8c0c9f622',
          FILLET = '47b36f8d-dc1b-402c-be3f-08d8c0c9f622',
          SLICING_CARVING = '4ab25b4e-a0fb-4216-be40-08d8c0c9f622',
          JAPANESE_STYLE = '85ce2d21-3b91-4ffe-be41-08d8c0c9f622',
          BONING = 'f7b3d802-7479-4594-be42-08d8c0c9f622',
          BUTCHER = '7eb2c7b2-9857-4e78-be43-08d8c0c9f622',
          UTILITY = 'd292fb07-774b-43ad-be3a-08d8c0c9f622',
          NAKIRI = 'ce3373e8-5106-459e-8d4a-08d92b8934dc',
          KIRITSUKE = '41dede5f-d49c-416b-8d4b-08d92b8934dc',
          COOKWARE = '52392c44-b1a8-4de0-c497-08d94c3c2df4',
          PREEZIE = 'PRE-6465dfad-c1d1-4e48-9edc-08d8c0ecd403';

        if (new_url.indexOf("/block-sets") > -1) {
          PREEZIE = KNIFE_SET;
        }
        if (new_url.indexOf("/chefs-") > -1) {
          PREEZIE = CHEF;
        }
        if (new_url.indexOf("/bread-") > -1) {
          PREEZIE = BREAD;
        }
        if (new_url.indexOf("/cleaver-") > -1) {
          PREEZIE = CLEAVER;
        }
        if (new_url.indexOf("/paring-") > -1) {
          PREEZIE = PARING;
        }
        if (new_url.indexOf("/filet-") > -1) {
          PREEZIE = FILLET;
        }
        if (new_url.indexOf("/slicers") > -1 || new_url.indexOf("/brisket-knives") > -1) {
          PREEZIE = SLICING_CARVING;
        }
        if (new_url.indexOf("/japanese-") > -1) {
          PREEZIE = JAPANESE_STYLE;
        }
        if (new_url.indexOf("/boning-") > -1) {
          PREEZIE = BONING;
        }
        if (new_url.indexOf("/butcher-") > -1) {
          PREEZIE = BUTCHER;
        }
        if (new_url.indexOf("cleaver-") > -1) {
          PREEZIE = CLEAVER;
        }
        if (new_url.indexOf("/utility-") > -1) {
          PREEZIE = UTILITY;
        }
        if (new_url.indexOf("/nakiri-") > -1) {
          PREEZIE = NAKIRI;
        }
        if (new_url.indexOf("/kiritsuke") > -1) {
          PREEZIE = KIRITSUKE;
        }
        var cookware_page = false;
        cookware.forEach(function (value) {
          if (new_url.indexOf(value) > -1) {
            cookware_page = true;
          }
        })
        var non_knives_page = false;
        non_knives.forEach(function (value) {
          if (new_url.indexOf(value) > -1) {
            non_knives_page = true;
          }
        })

        if (!non_knives_page && !cookware_page) {
          PREEZIE_GUIDE.render([
            {
              guideKey: PREEZIE,
              version: '1.0.0',
              renderTo: 'preezie-widget-div-id'
            }
          ]);
        }
        else if (cookware_page) {
          PREEZIE_GUIDE.render([
            {
              guideKey: COOKWARE,
              version: '1.0.0',
              renderTo: 'preezie-widget-div-id'
            }
          ]);
        }

      }
    }
    $(document).ready(function () {
      SectionUpdate();
      renderPREEZIE();
    });



    let click_count = 0;
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        onUrlChange();
      }
    }).observe(document, { subtree: true, childList: true });


    function onUrlChange() {
      SectionUpdate();
      renderPREEZIE();
      setTimeout(function () { customAddCart(); }, 500);
      if (click_count < 1) {
        setTimeout(function () { renderPREEZIE(); }, 1500);
        click_count++;
      }

    }


    $('[id^="shopify-section-template--"] .promo-grid').show();

  }
  //COLECTION CONTAINER SHOW
  $('#CollectionAjaxContent').fadeIn(500);

  //COMPARE PAGE & COMPARE SECTION
  if ($('.compare-section-home').length > 0 || window.location.href.indexOf('pages/compare') > -1) {
    function infoRenderer(text, img) {
      return (
        (img == null ? '' : '<img class="feat_icon" src="' + img + '" >') +
        (text == null ? '<p>-</p>' : '<p>' + text + '</p>')
      )
    }
    function renderProduct(data, targetColumn) {
      var isProductPage = false;
      if (window.location.href.indexOf("/products/") > -1) {
        isProductPage = true;
      }
      var productMeta = JSON.parse(data);
      var productTitle = productMeta.product.title.replace(/"/g, "&quot;");
      productTitle = productTitle.replace(/'/g, "&#039;");
      if (isProductPage && targetColumn == '.column--0') {
        $('.image' + targetColumn).html('<img class="lazyload" data-src="' + productMeta.product.image + '" alt="' + productMeta.product.title + '">' +
          '<h4>' + productMeta.product.title + '</h4>');
      }
      else {
        if (!isProductPage) {
          fetch('/products/' + productMeta.product.link.replace('/products/', '') + '.js')
            .then(res => res.json())
            .then((data_product) => {
              $('.image' + targetColumn).addClass('product-section');
              $('.image' + targetColumn).attr({
                'id': 'AddToCartForm-template--14179516711047__page-compare-' + data_product.id,
                'data-product-url': data_product.url,
                'data-product-handle': data_product.handle,
                'data-section-type': 'product',
                'data-section-id': data_product.id,
                'data-product-id': data_product.id

              });

              var itemFirstVariantId = '';
              if (data_product.has_only_default_variant) {
                itemFirstVariantId = data_product.variant.id;
              }
              else {
                data_product.variants.forEach(function (variant) {
                  itemFirstVariantId = variant.id;
                });
              }
              var addToCartBtn = '';
              if (data_product.available) {
                addToCartBtn = '<div class="payment-buttons"><button type="button" name="add" data-add-to-cart class="btn btn--full custom-add-cart" aria-expanded="false" data-product-id="' + itemFirstVariantId + '">' +
                  '<span data-add-to-cart-text data-default-text="">Add to cart</span></button></div>';
              }
              else {
                addToCartBtn = '<button type="submit" name="add" id="AddToCart-' + data_product.id + '" class="btn btn--full add-to-cart" aria-expanded="false" disabled="disabled">' +
                  '<span id="AddToCartText-' + data_product.id + '" data-default-text="">SOLD OUT</span></button>';
              }
              $('.image' + targetColumn).html('<a class="image-link" href="' + data_product.url + '"><img class="lazyload" data-src="' + data_product.featured_image + '" alt="' + data_product.title + '"></a>' +
                '<a class="image-link product-title" href="' + data_product.url + '"><h4>' + data_product.title + '</h4></a>' + addToCartBtn + '<button class="btn btn--secondary btn--small compare__modal-changeBtn" data-product="' + data_product.url + '" data-title="' + productTitle + '">Change</button>');
            });
        }
        else {
          $('.image' + targetColumn).html('<a class="image-link" href="' + productMeta.product.link + '"><img class="lazyload" data-src="' + productMeta.product.image + '" alt="' + productMeta.product.title + '"></a>' +
            '<a class="image-link product-title" href="' + productMeta.product.link + '"><h4>' + productMeta.product.title + '</h4></a> <button class="btn btn--secondary btn--small compare__modal-changeBtn" data-product="' +
            productMeta.product.link + '" data-title="' + productTitle + '">Change</button>' +
            '<a href="' + productMeta.product.link + '" class="btn btn--secondary btn--small">Learn More</a>');
        }
      }
      $('.Steel' + targetColumn).html(
        infoRenderer(productMeta.metafields.Steel, productMeta.metafields.Steel_Icon)
      );
      $('.steel_thikness' + targetColumn).html(
        infoRenderer(productMeta.metafields.Steel_Thickness, productMeta.metafields.Steel_Thickness_Icon)
      );
      $('.Handle' + targetColumn).html(
        infoRenderer(productMeta.metafields.Handle, productMeta.metafields.Handle_Icon)
      );
      $('.knife_weight' + targetColumn).html(
        infoRenderer(productMeta.metafields.Knife_Weight, productMeta.metafields.Knife_Weight_Icon)
      );
      $('.Blade-Angle' + targetColumn).html(
        infoRenderer(productMeta.metafields.Blade_Angle, productMeta.metafields.Blade_Angle_Icon)
      );
      $('.Rockwell' + targetColumn).html(
        infoRenderer(productMeta.metafields.Rockwell, productMeta.metafields.Rockwell_Icon)
      );
      $('.special_feature' + targetColumn).html(
        infoRenderer(productMeta.metafields.Special_Feature, productMeta.metafields.Special_Feature_Icon)
      );
      $('.who-is' + targetColumn).html(
        infoRenderer(productMeta.metafields.Who_Is_This_Knife_For, productMeta.metafields.Who_Is_This_Knife_For_Icon)
      );
      $('.Packaging-Components  + targetColumnp').html(productMeta.metafields.Packaging_Components == null ? '-' : productMeta.metafields.Packaging_Components);

    }
    function ctaButtons() {
      setTimeout(function () {
        $(".compare__modal-changeBtn").each(function (index) {
          $(this).on('click', function () {
            // $('.productList__Item .btn.compare').addClass()
            $('.compare__modal-footer #selected-product').html($(this).data('title'));
            $("#compare__myModal").removeClass('column-0 column-1 column-2');
            $("#compare__myModal").addClass('column-' + index);
            openKnifeSelector();
          });
        });
        if (theme.settings.cartType === 'drawer') {
          $('.product-section').each(function () {
            //var sectionId = $(this).attr('data-section-id');
            //new theme.AjaxProduct($('#AddToCartForm-' + sectionId));
          })
        }
      }, 1000);
    }
    //SET COMPARE DATA VARIABLES
    var compareData = JSON.parse(localStorage.getItem('compare__products'));
    var recentlyViewedProduct = JSON.parse(localStorage.getItem('nf_recent_v'));
    var compare__products = ['ss-x-8-in-chef', 'gs-8-in-chef'];
    var urlPath = window.location.pathname.split("/products/");

    // Get the modal
    var modal = $("#compare__myModal");
    // Get the <span> element that closes the modal
    var close = $(".compare__modal-close");
    function openKnifeSelector() {
      var compareData = JSON.parse(localStorage.getItem('compare__products'));
      $('.productList__Item').each(function () {
        $(this).removeClass('selected-product');
        $(this).find('.btn.compare-product').attr({ 'disabled': false }).html('Compare <span>+</span>');
        for (let compareDataItem = 0; compareDataItem < compareData.length; compareDataItem++) {
          if (compareData[compareDataItem] == $(this).data('product')) {
            $(this).addClass('selected-product');
            $(this).find('.btn.compare-product').attr({ 'disabled': true }).html('Selected');

          }
        }
        $("#compare__myModal").fadeIn(500);
      });
    }
    // When the user clicks on <span> (x), close the modal
    close.on('click', function () {
      $("#compare__myModal").removeClass('column-0 column-1 column-2');
      modal.fadeOut(300);
    })

    // When the user clicks anywhere outside of the modal, close it
    $(window).on('click', function (event) {
      if (event.target == modal[0]) {
        close.click();
      }
    });

    //SEARCH BAR
    $('#searchProduct').keyup(function () {
      $('#knife_series').prop("selectedIndex", 0);
      $('#knife_type').prop("selectedIndex", 0);
      var input, filter, productList, productList__Item, a, i, txtValue;
      input = document.getElementById('searchProduct');
      filter = input.value.toUpperCase();
      productList = document.getElementById("productList");
      productList__Item = document.querySelectorAll('.productList__Item');
      // Loop through all List items, and hide those who don't match the search query
      for (i = 0; i < productList__Item.length; i++) {
        a = productList__Item[i].getElementsByTagName("p")[0];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          $(productList__Item[i]).fadeIn(300);
        } else {
          $(productList__Item[i]).fadeOut(300);
        }
      }
    });
    //FILTER BAR 
    $('#knife_series').on('change', function () {
      $('#knife_type').prop("selectedIndex", 0);
      $('#searchProduct').val('');
      filterSelection($(this).val());
    });
    $('#knife_type').on('change', function () {
      $('#knife_series').prop("selectedIndex", 0);
      $('#searchProduct').val('');
      filterSelection($(this).val());
    });
    function filterSelection(c) {
      var x;
      x = document.getElementsByClassName("productList__Item");
      if (c == "all") c = "";
      $('.productList__Item').each(function () {
        $(this).fadeOut(300);
        if ($(this)[0].className.toLowerCase().indexOf(c) > -1) {
          $(this).fadeIn(300);
        }
      });
    }
    //COMPARE SELECT BUTTON CLICK
    $(".btn.compare-product").each(function () {
      $(this).on('click', function () {
        // $('.productList__Item .btn.compare').addClass()
        var columnNumber;
        if ($('#compare__myModal').hasClass('column-0')) {
          columnNumber = 0;
        }
        else if ($('#compare__myModal').hasClass('column-1')) {
          columnNumber = 1;
        }
        else if ($('#compare__myModal').hasClass('column-2')) {
          columnNumber = 2;
        }
        //Update Compare Product
        if (window.location.href.indexOf("/products/") > -1) { columnNumber++; }

        $.get('/products/' + $(this).data('product') + '?view=json', function (data) { renderProduct(data, '.column--' + columnNumber); });
        ctaButtons();
        //Save Data
        var compareData = JSON.parse(localStorage.getItem('compare__products'));
        if (compareData) {
          var newCompareData = compareData;
          newCompareData[columnNumber] = $(this).data('product');
          localStorage.setItem("compare__products", JSON.stringify(newCompareData));
        }
        //Colse Modal
        close.click();
      });
    });
    //STICKY IMAGE SECTION 
    $(window).scroll(function () {
      if ($(".compare-section").length > 0) {
        var top_of_element = $(".compare-section").offset().top - 100;
        //var bottom_of_element = $(".compare-section").offset().top + $(".compare-section").outerHeight();
        //var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();
        //if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        if (top_of_screen < top_of_element) {
          // the element is visible, do something
          $('#imageSection').removeClass('sticky--section');
        }
        if (top_of_screen > top_of_element) {
          $('#imageSection').addClass('sticky--section');
        }
      }
    });

    ctaButtons();

  }

  //PRODUCT PAGE COMPARE SECTION
  if (window.location.href.indexOf("/products/") > -1 && $(".compare-section").length > 0) {
    if (compareData) {
      var dataExist = true;
      var loopCounter = 1;
      for (let compareDataItem = 0; compareDataItem <= compareData.length; compareDataItem++) {
        if (compareData[compareDataItem] == urlPath[1]) {
          dataExist = false;
        }
        else if (compareData[compareDataItem] != urlPath[1] && loopCounter < 3) {
          $.get('/products/' + compareData[compareDataItem] + '?view=json', function (data) { renderProduct(data, '.column--' + loopCounter); loopCounter++; });
        }
      }
      if (dataExist) {
        var newCompareData = compareData;
        if (compareData.length > 2) {
          newCompareData[2] = compareData[1];

        }
        newCompareData[1] = compareData[0];
        newCompareData[0] = urlPath[1];


        localStorage.setItem("compare__products", JSON.stringify(newCompareData));

      }
    }
    //if no compare data look for recently viewed products
    else {
      if (urlPath[1] == compare__products[0]) {
        $.get('/products/' + compare__products[1] + '?view=json', function (data) { renderProduct(data, '.column--1'); });
      }
      else if (urlPath[1] == compare__products[1]) {
        $.get('/products/' + compare__products[0] + '?view=json', function (data) { renderProduct(data, '.column--1'); });
      }
      else {
        $.get('/products/' + compare__products[0] + '?view=json', function (data) { renderProduct(data, '.column--1'); });
        $.get('/products/' + compare__products[1] + '?view=json', function (data) { renderProduct(data, '.column--2'); });
        compare__products.push(compare__products[1]);
        compare__products[1] = compare__products[0];
        compare__products[0] = urlPath[1];
      }
      localStorage.setItem("compare__products", JSON.stringify(compare__products));
    }
    //LOAD COMPARE SECTION FIRST COLUMN
    $.get('/products/' + urlPath[1] + '?view=json', function (data) { renderProduct(data, '.column--0'); });
  }

  //COMPARE PAGE
  if (window.location.href.indexOf('pages/compare') > -1) {
    //has a saved compare data
    if (compareData) {
      for (let compareDataItem = 0; compareDataItem < compareData.length; compareDataItem++) {

        $.get('/products/' + compareData[compareDataItem] + '?view=json', function (data) { renderProduct(data, '.column--' + compareDataItem); });
      }
    }
    //if no compare data look for recently viewed products
    else if (recentlyViewedProduct) {
      var newCompareData = compare__products;
      for (let i = 0; i < 2; i++) {
        if (recentlyViewedProduct.i.length == 1) {
          if (i == 0) {
            $.get('/products/' + recentlyViewedProduct.i[i].h + '?view=json', function (data) { renderProduct(data, '.column--' + i); });
            newCompareData[0] = recentlyViewedProduct.i[i].h;
          }
          if (i == 1) {
            if (recentlyViewedProduct.i[0].h == compare__products[0]) {
              $.get('/products/' + compare__products[1] + '?view=json', function (data) { renderProduct(data, '.column--' + i); });
              newCompareData[1] = compare__products[1];
            }
            else if (recentlyViewedProduct.i[0].h == compare__products[1] || recentlyViewedProduct.i[0].h != 'ss-x-8-in-chef') {
              $.get('/products/' + compare__products[0] + '?view=json', function (data) { renderProduct(data, '.column--' + i); });
              newCompareData[1] = compare__products[0];
            }
          }

        }
        else {
          $.get('/products/' + recentlyViewedProduct.i[i].h + '?view=json', function (data) { renderProduct(data, '.column--' + i); });
          newCompareData[i] = recentlyViewedProduct.i[i].h;
        }
      }
      localStorage.setItem("compare__products", JSON.stringify(newCompareData));
    }
    //if no compare data and recently viewed products load default products
    else {
      localStorage.setItem("compare__products", JSON.stringify(compare__products));
      compareData = JSON.parse(localStorage.getItem('compare__products'));
      for (let compareDataItem = 0; compareDataItem < compareData.length; compareDataItem++) {
        $.get('/products/' + compareData[compareDataItem] + '?view=json', function (data) { renderProduct(data, '.column--' + compareDataItem); });
      }
    }
  }

  //BLOG PAGE - INFINITE SCROLL
  if (window.location.href.indexOf('/blogs/news') > -1 && window.location.href.indexOf('/blogs/news/') < 0) {

    var endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'click'
    });

  }
  // BLOG ARTICLE PAGE - For table of content and mobile subcription form display
  if (window.location.href.indexOf('/blogs/') > -1) {
    const join = document.querySelector(".show_form")
    const form = document.querySelector(".mobile_subcribe_now")

    if (join) {
      join.addEventListener('click', () => {
        form.classList.toggle("active")
      })
    }

    if (document.getElementById("table")) {

      const x = Array.from(document.getElementById("table").children)

      var newlistDiv = document.getElementById("new_table")
      var newlist = "<ol>"
      x.forEach(function (y, i) {
        var section = parseInt(i) + 1
        newlist += "<li><a class ='smooth_scroll' href = '#section" + section + "'>" + y.innerText + "</a></li>"
      })
      newlist += "</ol>"

      newlistDiv.innerHTML = newlist
    }

    if (document.getElementById("table")) {

      const x = Array.from(document.getElementById("table").children)

      var newlistDiv = document.getElementById("mobile_table")
      var newlist = "<ol>"
      x.forEach(function (y, i) {
        var section = parseInt(i) + 1
        newlist += "<li><a class ='smooth_scroll' href = '#section" + section + "'>" + y.innerText + "</a></li>"
      })
      newlist += "</ol>"

      newlistDiv.innerHTML = newlist
    }

  }

  //VIDEO COLLECTION CUSTOM PAGE
  if (window.location.href.indexOf('/dalstrong-films') > -1) {
    $('.video-thumb').each(function () {
      $(this).click(function () {
        if ($(this).data('videoId') != '') {
          if ($(this).data('videoType') == 'youtube') {
            $('#videoModal .video-wrapper').html('<iframe src="//www.youtube.com/embed/' + $(this).data('videoId') + '?rel=0&showinfo=0&vq=720" width="850" height="480" frameborder="0" allowfullscreen></iframe>')
          }
          if ($(this).data('videoType') == 'vimeo') {
            $('#videoModal .video-wrapper').html('<iframe src="//player.vimeo.com/video/' + $(this).data('videoId') + '?color={{ settings.color_button | remove: "#" }}&byline=0&portrait=0&badge=0" width="850" height="480" frameborder="0" allowfullscreen></iframe>')
          }
        }
        else {
          $('#videoModal .video-wrapper').html('<iframe src="//www.youtube.com/embed/_9VUPq3SxOc?rel=0&showinfo=0&vq=720" width="850" height="480" frameborder="0" allowfullscreen></iframe>')
        }

        $('#videoModal').fadeIn();

      })
    });

    $('#video-modal-close').click(function () {
      $('#videoModal .video-wrapper').html('');
      $('#videoModal').fadeOut();
    });

    window.onclick = function (event) {
      if (event.target == $('#videoModal')[0]) {
        $('#videoModal .video-wrapper').html('');
        $('#videoModal').fadeOut();
      }
    }
  }

  // ----------- GLOBAL ------------ //

  //COUNTRY SELECTOR TOP BAR
  const showCountrySelector = document.querySelector('#showCountrySelector');
  const switchLocation = document.querySelector('#switchLocation.modal');
  showCountrySelector?.addEventListener('click', function() {
    switchLocation.style.display = 'block';
  });

  switchLocation?.addEventListener('click', function(e) {
    if (e.target.classList.contains('adl-close') || e.target.id === 'switchLocation') {
      switchLocation.style.display = 'none';
    }
  });

  //CUSTOM ADD TO CART
  // function customAddCart() {
  //   document.querySelectorAll('.custom-add-cart').forEach(function(addToCart) {
  //     addToCart.addEventListener('click', function(evt) {
  //       evt.preventDefault();
  //       evt.target.classList.add('btn--loading');
        
  //       const addData = {
  //         'id': evt.target.dataset.productId,
  //         'quantity': 1
  //       };
  //       if (evt.target.dataset.preorder)  {
  //         addData.properties = { 'Pre-Order': 'Pre-Order' };
  //       }

  //       fetch('/cart/add.js', {
  //         body: JSON.stringify({ items: [addData] }),
  //         credentials: 'same-origin',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'X-Requested-With': 'xmlhttprequest'
  //         },
  //         method: 'POST'
  //       })
  //         .then(response => response.json())
  //         .then(() => {
  //           document.dispatchEvent(new CustomEvent('cart:build'));
  //           document.querySelector('a.js-drawer-open-cart').click();
  //           this.classList.remove('btn--loading');
  //           cartItemCounter(true);
  //         })
  //         .catch(err => {
  //           console.error(err);
  //         });
  //     });
  //   });
  // }
  function customAddCart() {
    document.querySelectorAll('.custom-add-cart').forEach(function(addToCart) {
      addToCart.addEventListener('click', function(evt) {
        evt.preventDefault();
        const button = evt.currentTarget;
        button.classList.add('btn--loading');

        const addData = {
          id: button.dataset.productId,
          quantity: 1
        };

        if (button.dataset.preorder) {
          addData.properties = { 'Pre-Order': 'Pre-Order' };
        }

        fetch('/cart/add.js', {
          body: JSON.stringify({ items: [addData] }),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          method: 'POST'
        })
        .then(response => response.json())
        .then(() => {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.querySelector('a.js-drawer-open-cart').click();
          button.classList.remove('btn--loading');
          cartItemCounter(true);
        })
        .catch(err => console.error(err));
      });
    });
  }

  customAddCart();

  //Update CART ITEMS COUNTER
  function cartItemCounter(withCartUpdate = false) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartBubble = document.querySelector('.cart-link__bubble--visible');
        if (cartBubble) {
          cartBubble.textContent = cart.item_count;
        }
        if (withCartUpdate) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      })
      .catch(err => {
        console.error('Error fetching cart:', err);
      });
  }

  let giftOutOfStock = false;

  async function addRandomVariantToCart(giftProducts, cart) {
    try {
      for (const gp of giftProducts) {
        if (!gp || !gp.handle) continue;

        const res = await fetch(`/products/${gp.handle}.js`);
        if (!res.ok) continue;
        const productData = await res.json();
        if (!productData || !productData.variants || !productData.variants.length) continue;

        const availableVariants = productData.variants.filter(v => v.available);
        if (availableVariants.length === 0) continue;

        const trulyAvailable = availableVariants.filter(v => {
          if (typeof v.inventory_quantity === 'undefined') return true;
          const inCart = cart.items
            .filter(item => item.variant_id === v.id)
            .reduce((sum, item) => sum + item.quantity, 0);
          return v.inventory_quantity > inCart;
        });

        if (trulyAvailable.length === 0) continue;

        const randomIndex = Math.floor(Math.random() * trulyAvailable.length);
        const variant = trulyAvailable[randomIndex];

        const payload = {
          items: [
            {
              id: variant.id,
              quantity: 1,
              properties: { '_isGift': 'yes' }
            }
          ]
        };

        const addRes = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
        if (!addRes.ok) {
          console.error('Gift add failed:', addRes.status);
          continue;
        }
        return addRes.json();
      }

      giftOutOfStock = true;
      return;
    } catch (err) {
      console.error("Error adding random variant:", err);
    }
  }
  
  // function handleCartItemsAccordingToPromo(subtotal, giftItems) {
  //   console.warn("handleCartItemsAccordingToPromo: ", subtotal, giftItems);
  //   const giftCard25 = '43434675994759';
  //   const giftCard50 = '43434676322439';
  //   const promises = [];
  //   if (subtotal >= 400) {
  //     console.warn("subtotal >= 400");
  //     const firstGiftItem = giftItems.find(item => item.variant_id == giftCard25);
  //     if (firstGiftItem) {
  //       promises.push(removeGiftFromCart(firstGiftItem.id));
  //     }

  //     const hasSecondGift = giftItems.some(item => item.variant_id == giftCard50);
  //     if (!hasSecondGift && !giftAddedThisUpdate) {
  //       giftAddedThisUpdate = true;
  //       promises.push(addGiftToCart(giftCard50));
  //     }
  //   } else if (subtotal >= 250) {
  //     console.warn("subtotal >= 250");
  //     const secondGiftItem = giftItems.find(item => item.variant_id == giftCard50);
  //     if (secondGiftItem) {
  //       promises.push(removeGiftFromCart(secondGiftItem.id));
  //     }

  //     const hasFirstGift = giftItems.some(item => item.variant_id == giftCard25);
  //     if (!hasFirstGift && !giftAddedThisUpdate) {
  //       giftAddedThisUpdate = true;
  //       promises.push(addGiftToCart(giftCard25));
  //     }
  //   } else {
  //     console.warn("ELSE: subtotal < 250");
  //     if (giftItems.length > 0) {
  //       giftItems.forEach(item => promises.push(removeGiftFromCart(item.id)));
  //     }
  //   }
  //   return Promise.all(promises);
  // }

  function handleCartItemsAccordingToPromo(subtotal, giftItems, cart) {
    const promo = window.freeGiftPromo;
    const promises = [];

    if (!isFreeGiftPromoActive(promo)) {
      giftItems.forEach(item => promises.push(removeGiftFromCart(item.id)));
      return Promise.all(promises);
    }

    const giftHandles = promo.freeGiftProducts.map(gp => gp.handle);
    const giftInCart = giftItems.find(item => giftHandles.includes(item.handle));
    const threshold = promo.cartTotalPrice || 350;

    if (!giftOutOfStock && subtotal >= threshold) {
      if (!giftInCart && !giftAddedThisUpdate) {
        giftAddedThisUpdate = true;
        promises.push(addRandomVariantToCart(promo.freeGiftProducts, cart));
      }
    } else {
      if (giftInCart) {
        promises.push(removeGiftFromCart(giftInCart.id));
      }
    }
    return Promise.all(promises);
  }

  function isFreeGiftPromoActive(promo) {
    if (!promo || !promo.freeGiftProducts || !promo.freeGiftProducts.length) return false;
    if (!promo.startTime || !promo.endTime) return false;

    const now = new Date();
    const startTime = new Date(promo.startTime);
    const endTime = new Date(promo.endTime);
    if (Number.isNaN(startTime.getTime()) || Number.isNaN(endTime.getTime())) return false;
    if (endTime <= startTime) return false;
    if (now < startTime) return false;
    if (now > endTime) return false;

    return true;
  }

  //SWIPER CAROUSEL
  const swiperElement = document.querySelector('.swiper.custom-js-swiper');
  if (swiperElement) {    
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 5,
      slidesPerColumnFill: 'row',
      slidesPerGroup: 5,
      spaceBetween: 5,
      freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        640: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        1020: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        }
      }
    });

    window.addEventListener('resize', () => {
      swiper.update();
    });
  }

  const excludedStudioForge = [43329691189383, 43078281068679, 42860147114119];

  function checkCartItems() {
    fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const giftItems = cart.items.filter(
        item => item.properties && item.properties._isGift == 'yes'
      );
      const giftTotal = giftItems.reduce((sum, item) => sum + (item.final_line_price || 0), 0);
      const excludedTotal = cart.items
        .filter(item => excludedStudioForge.includes(item.variant_id))
        .reduce((sum, item) => sum + (item.final_line_price || 0), 0);
      const subtotal = (cart.total_price - giftTotal - excludedTotal) / 100;
      return handleCartItemsAccordingToPromo(subtotal, giftItems, cart);
    })
    .then((promiseData) => {
      giftAddedThisUpdate = false;
      if (promiseData.length > 0) document.dispatchEvent(new CustomEvent('cart:build'));
    })
    .catch(err => {
      console.error('Gift check error:', err);
      document.dispatchEvent(new CustomEvent('cart:build', {
        detail: { promiseData: err }
      }));
    });
  }

  function addGiftToCart(giftProduct) {
    if (!giftProduct) {
      console.error('No gift product ID provided');
      return;
    }
    
    const variantId = typeof giftProduct === 'string' ? parseInt(giftProduct, 10) : giftProduct;
    
    if (isNaN(variantId)) {
      console.error('Invalid gift product ID:', giftProduct);
      return;
    }

    const addData = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: { '_isGift': 'yes' }
      }]
    };
    return fetch('/cart/add.js', {
      body: JSON.stringify(addData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
      },
      method: 'POST'
    }).then(response => {
      if (!response.ok) {
        return response.json().then(errorData => {
          console.error('Error response from server:', errorData);
          throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.message || errorData.description || 'Unknown error'}`);
        }).catch(jsonError => {
          // If we can't parse JSON, throw the original error
          if (jsonError.message && jsonError.message.includes('HTTP error!')) {
            throw jsonError;
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        });
      }
      return response.json();
    }).catch((err) => {
      console.error('Error adding gift:', err);
      console.error('Gift product ID:', giftProduct);
      console.error('Request data:', addData);
    });
  }

  function removeGiftFromCart(giftProductRemove) {
    if (!giftProductRemove) {
      console.error('No gift product ID provided for removal');
      return;
    }
    
    const removeData = {
      updates: { [giftProductRemove]: 0 }
    };
    return fetch('/cart/update.js', {
      body: JSON.stringify(removeData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
      },
      method: 'POST'
    }).then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          throw new Error(`HTTP error! status: ${response.status}, message: ${JSON.stringify(err)}`);
        });
      }
      return response.json();
    }).catch(err => {
      console.error('Error removing gift:', err);
    });
  }

  //CART UPDATE LISTENER
  document.addEventListener('cart:updated', function (evt) {
    if (theme.canUpdateCart()) {
      checkCartItems();
    }
    cartItemCounter();
  });

  window.addEventListener('ppJustConverted', () => {
    cartItemCounter(true);
  }, false)

  const cartContainer = document.getElementById('CartDrawer');
  if (cartContainer) {
    cartContainer.addEventListener('click', (e) => {
      const checkoutButton = document.querySelector('button.cart__checkout');
      if (e.target.closest('button:not(.cart__checkout):not(.drawer__close-button)')) {
        if (checkoutButton) {
          checkoutButton.disabled = true;
          checkoutButton.classList.add('btn--loading', 'disabled');
          setTimeout(() => {
            checkoutButton.disabled = false;
            checkoutButton.classList.remove('btn--loading', 'disabled');
          }, 2000);
        }
      }
    });
  }

});
